<template>
  <div>
    <template v-if="!config.previewSrc && (!config.ext || !typeMap[config.ext.toLowerCase()] || !config.src)">{{
      config.noDisplayText || ""
    }}</template>
    <template v-else-if="config.previewSrc || typeMap[config.ext.toLowerCase()] === 'web'">
      <iframe class="e-document-view-iframe" :src="config.src"></iframe>
    </template>
  </div>
</template>

<script>
export default {
  name: 'document-view',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      typeMap: {
        png: 'web',
        bmp: 'web',
        jpg: 'web',
        jpeg: 'web',
        gif: 'web',
        pdf: 'web',
        txt: 'web'
      }
    };
  },
  methods: {}
};
</script>

<style scoped></style>
